export var IDENTIFIER_CHECKLIST = 'checklist';
export var IDENTIFIER_CHECKLIST_ITEM = 'checklist-item';
